function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 3H2C0.91 3.04 0.04 3.91 0 5V19C0.04 20.09 0.91 20.96 2 21H22C23.09 20.96 23.96 20.09 24 19V5C23.9816 4.47543 23.765 3.97734 23.3938 3.60619C23.0227 3.23503 22.5246 3.01841 22 3ZM22 19H2V5H22V19ZM14 7V8H20V7H14ZM14 9V10H20V9H14ZM14 11V12H18V11H14Z",
  className: "icon-primary"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4 17V7H7.77079C9.07702 7 10.0678 7.23352 10.7431 7.70055C11.4184 8.163 11.756 8.84295 11.756 9.74038C11.756 10.2303 11.6205 10.663 11.3494 11.0385C11.0783 11.4093 10.7012 11.6818 10.2181 11.8558C10.7702 11.984 11.2039 12.2427 11.5194 12.6319C11.8398 13.0211 12 13.4973 12 14.0604C12 15.022 11.6697 15.75 11.0092 16.2445C10.3487 16.739 9.40727 16.9908 8.18484 17H4ZM6.21811 12.6456V15.3448H8.1183C8.64079 15.3448 9.04744 15.2303 9.33826 15.0014C9.63401 14.7679 9.78189 14.4473 9.78189 14.0398C9.78189 13.1241 9.27172 12.6593 8.25139 12.6456H6.21811ZM6.21811 11.1896H7.85952C8.97844 11.1712 9.53789 10.7569 9.53789 9.94643C9.53789 9.49313 9.39495 9.16804 9.10906 8.97115C8.8281 8.76969 8.38201 8.66896 7.77079 8.66896H6.21811V11.1896Z",
  className: "icon-primary"
});

function SvgKyb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    className: "icon-primary",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyb);
export default __webpack_public_path__ + "static/media/kyb.5309fae5.svg";
export { ForwardRef as ReactComponent };